<template>
    <div class="container">
        <!-- <div class="lecture">
            <template v-if="lecture != null" >
                <div class="lecture-info"> 
                    <h3> {{lecture.subject}} </h3>
                    <h4> {{lecture.batch}} </h4>
                    <h4> {{lecture.startTime}} - {{lecture.endTime}} </h4>
                </div>
            </template>
            <template v-else>
                <content-loader
                    :speed="1"
                    primaryColor="#cccccc"
                    secondaryColor="#ecebeb"
                >
                    <rect x="100" y="25" rx="6" ry="4" width="250" height="15" /> 
                    <rect x="100" y="100" rx="6" ry="4" width="250" height="15" /> 
                    
                 </content-loader>
            </template>
        </div> -->
        <div class="info">
            <div class="info-text">
                <p v-if="role =='faculty'"> 
                    You can start Class 5 minutes prior to scheduled time. The class can go upto maximum 5 minutes after scheduled end time.
                    <br>
                    Plan your lectures accordingly.
                    
                </p>
            </div>
            <div class="info-controls">
                <div class="options" v-if="role =='faculty'">
                    <div class="form-group">
                        <label class="label" for="webcam">
                            <div class="label-text">
                                <h4>Start by Webcam feed</h4>
                            </div>
                            <div class="radio-container">
                                <input type="radio" id="webcam" value="webcam"  name="feed" v-model="feed" checked>
                                
                                <span class="custom-radio"></span>
                            </div>
                        </label>
                    </div>
                    <div class="form-group">
                        <label class="label" for="screen-share">
                            <div class="label-text">
                                <h4>Start by screen share</h4>
                            </div>
                            <div class="radio-container">
                                <input type="radio" id="screen-share" name="feed" value="screen_share" v-model="feed">
                                <span class="custom-radio"></span>
                            </div>
                        </label>
                        
                        
                    </div>
            
                    <div class="form-group">
                         <label class="label" for="audio-type">
                            <div class="label-text">
                                <h4>Mute Audio</h4>
                            </div>
                            <div class="checkbox-container">
                                <input type="checkbox"  id="audio-type" v-model="audio_muted">
                                <span class="custom-checkbox"></span>
                            </div>
                        </label>
                    </div>
                </div>
                <button :class="{inactive:isStartLectureDisabled}" :disabled="isStartLectureDisabled" @click="start_lecture" v-if="role =='faculty'">
                    Start Lecture
                    <!-- {{time_to_lecture}} -->
                    <!-- {{time | moment("dddd, h:mm:ss a")  }} -->
                </button>
                <button @click="attend_lecture" v-if="role =='student'">Attend Lecture</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
export default {
    data(){
        return {
            role:"",
            feed:"webcam",
            webcam:false,
            screen_share:false,
            audio_muted:false,
        }
    },
    components:{
        ContentLoader
    },
    computed: {

        time() {
            return this.$store.state.time
        },
        lecture(){
            console.log(("store ",this.$store.state.lecture))
            return this.$store.state.lecture
        },
        isStartLectureDisabled(){
            let lecture = this.lecture
            let time = this.time
            if(lecture !=null){
                let startTime = new Date()
                startTime.setHours(`${lecture.startTime.split(':')[0]}`)
                startTime.setMinutes(`${lecture.startTime.split(':')[1]}`)
                startTime.setSeconds(`0`)
                let diffInMilliSeconds = startTime - time
                
                const minutes = diffInMilliSeconds*1.66667e-5
                // console.log('minutes', minutes);
                if(minutes<=5) return false;
            }
            return false
        }
        
    },
    created(){
        this.role = localStorage.getItem('role')
    },
    methods:{
        start_lecture(ev){
            ev.preventDefault();
            if(this.feed == "webcam") this.webcam = true;
            else if(this.feed == "screen_share") this.screen_share=true
            localStorage.setItem('video_muted',!this.webcam)
            localStorage.setItem('screen_share',this.screen_share)
            localStorage.setItem('audio_muted',this.audio_muted)
            this.$router.push('/dashboard/class')
        },
        attend_lecture(ev){
            ev.preventDefault()
            this.$router.push('/dashboard/attend')
        }
    }
}
</script>

<style scoped>
.container{
    height: 100%;
    width: 100%;
    background-color: #d3daee;
    position: relative;
}
/* .lecture{
    outline: 2px solid red;
} */
.lecture-info{
    outline: 2px solid red;
    width: max-content;
    padding:1rem 4rem
}
.lecture-info h3{
    font-size: 2.4rem;
    padding:.5rem 0 ;
    color: #2d2d2d;
}
.lecture-info h4{
    font-size: 1.8rem;
    display: inline-block;
    margin-right: 2rem;
    color:#585858
}
.info{
    position: absolute;
    top:40%;
    left:50%;
    text-align: center;
    min-width: 55rem;
    transform: translate(-50%,-50%);
}
.info-text p{
    color: #a0a0a0;
    text-align: center;
    font-size: 2rem;
}
.info-controls{
    margin-top: 3rem;
}
.options{
    /* outline: 2px solid red; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
}
.form-group{
    position: relative;
    padding-left: 2.4rem;
    /* padding-top: .2rem; */
}
.form-group label h4{
    font-size: 1.6rem;
}

.info-controls button{
    margin-top: 2rem;
    padding: 1rem 2rem;
    background-color: #002486;
    color:white;
    font-size: 1.6rem;
}
.inactive{
    background-color: #a0a0a0 !important;
    color:#ebebeb !important;
}
.inactive:hover{
    cursor: not-allowed;
}

@media only screen and (max-width: 500px ) {
    .info{min-width:95%}
}


</style>


// WEBPACK FOOTER //
// src/views/StartClass.vue